import Vue from "vue";

import ApiService from "@/common/api.service";
import SessionService from "@/common/session.service";

import { CREATE_SESSION } from "@/store/actions.type";

import { SET_SESSION } from "@/store/mutations.type";

const state = {
  session: {}
};

const getters = {
  session(state) {
    return state.session;
  }
};

const actions = {
  [CREATE_SESSION](context, payload) {
    return new Promise((resolve, reject) => {
      SessionService.create(payload)
        .then(e => {
          context.commit(SET_SESSION, e.data.data);
          resolve(e);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  [SET_SESSION](state, data) {
    state.session = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
